/**
 * Centralized color tokens for the CIN-5774 discontinued-service indicators.
 *
 * Iter-1 thru iter-4 mapped these straight to Figma `light/yellow/200|600|700`
 * (`#fdf6bf`, `#d5ab07`, `#946c05`). Emii's iter-5 review flagged the indicators
 * as not accessible enough — see TODO note below.
 *
 * One source of truth for all four surfaces:
 *   - <DiscontinuedServiceChip>          (chip border + icon + label color)
 *   - <DiscontinuedServiceCard>          (card stripe + body bg + warning row)
 *   - schedule-detail-modal Services row (amber row tint + warning triangle)
 *
 * TODO design QA: Iter-5 darkened `accent` (`#d5ab07` → `#946c05`) and `deep`
 * (`#946c05` → `#5a4203`) to satisfy WCAG AA on the 12px chip label / bottom
 * warning text and the 3:1 UI-component threshold for the border/stripe. The
 * pale yellow body bg `#fdf6bf` is preserved as the visual cue. Confirm with
 * Emii / design system before this lands as a permanent token.
 *
 *   bg `#fdf6bf` (Figma `light/yellow/200`) — unchanged
 *   accent `#946c05` vs bg → ~4.25:1 (passes 3:1 UI threshold, passes AA-large)
 *   deep   `#5a4203` vs bg → ~7:1   (passes AA-normal, passes AAA-large)
 */
export const DISCONTINUED_TOKENS = Object.freeze({
  // Pale yellow tint — card body bg, amber row tint
  bg: '#fdf6bf',
  // Darkened from `#d5ab07` to satisfy 3:1 UI threshold for borders/stripe
  accent: '#946c05',
  // Darkened from `#946c05` to satisfy 4.5:1 AA threshold for 12px label/text
  deep: '#5a4203'
});
export default DISCONTINUED_TOKENS;